/**
 * Construct query params and cache key for Product and ProductOffering
 *
 * @param {?string} sn
 * @param {?string} billingAccountId
 * @return {[object, string]}
 * @private
 */
export function getIdentityQueryAndCacheKey({ sn = null, billingAccountId = null }) {
  if (sn) {
    return [{ publicKey: sn }, `sn-${sn}`];
  }
  if (billingAccountId) {
    return [
      {
        'relatedParty.type': 'billingAccount',
        'relatedParty.id': billingAccountId,
      },
      `billingAccountId-${billingAccountId}`,
    ];
  }
  throw new Error('One of following must be specified: sn, billingAccountId');
}
